var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F1F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 11H16C13.2386 11 11 13.2386 11 16V26C11 28.7614 13.2386 31 16 31H26C28.7614 31 31 28.7614 31 26V16C31 13.2386 28.7614 11 26 11Z",
    stroke: "#0050F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.3701C25.1234 21.2023 24.9813 22.0523 24.5938 22.7991C24.2063 23.5459 23.5932 24.1515 22.8416 24.5297C22.0901 24.908 21.2385 25.0397 20.4078 24.906C19.5771 24.7723 18.8098 24.3801 18.2149 23.7852C17.6199 23.1903 17.2277 22.4229 17.0941 21.5923C16.9604 20.7616 17.0921 19.91 17.4703 19.1584C17.8486 18.4069 18.4542 17.7938 19.201 17.4063C19.9478 17.0188 20.7978 16.8766 21.63 17.0001C22.4789 17.1259 23.2649 17.5215 23.8717 18.1284C24.4785 18.7352 24.8741 19.5211 25 20.3701Z",
    stroke: "#0050F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5H26.51",
    stroke: "#0050F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9a7fa793346d5ff32e1ba69ea9828363.svg";
export { ForwardRef as ReactComponent };